import { render, staticRenderFns } from "./IngredientSeasons.vue?vue&type=template&id=0a2bf850&scoped=true&"
import script from "./IngredientSeasons.vue?vue&type=script&lang=js&"
export * from "./IngredientSeasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2bf850",
  null
  
)

export default component.exports